module.exports = [
	{
		"name": "Soldier: 76",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "soldier.png",
		"roleRank": 3
	},
	{
		"name": "Reaper",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "reaper.png",
		"roleRank": 1
	},
	{
		"name": "Pharah",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "pharah.png",
		"roleRank": 6
	},
	{
		"name": "Genji",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "genji.png",
		"roleRank": 2
	},
	{
		"name": "McCree",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "mccree.png",
		"roleRank": 5
	},
	{
		"name": "Tracer",
		"role": "Offense",
		"teamRole": "dps",
		"icon": "tracer.png",
		"roleRank": 4
	},
	{
		"name": "Bastion",
		"role": "Defense",
		"teamRole": "dps",
		"icon": "bastion.png",
		"roleRank": 4
	},
	{
		"name": "Hanzo",
		"role": "Defense",
		"teamRole": "dps",
		"icon": "hanzo.png",
		"roleRank": 3
	},
	{
		"name": "Junkrat",
		"role": "Defense",
		"teamRole": "dps",
		"icon": "junkrat.png",
		"roleRank": 1
	},
	{
		"name": "Mei",
		"role": "Defense",
		"teamRole": "support",
		"icon": "mei.png",
		"roleRank": 2
	},
	{
		"name": "Torbjörn",
		"role": "Defense",
		"teamRole": "dps",
		"icon": "torbjorn.png",
		"roleRank": 5
	},
	{
		"name": "Widowmaker",
		"role": "Defense",
		"teamRole": "dps",
		"icon": "widowmaker.png",
		"roleRank": 6
	},
	{
		"name": "D.Va",
		"role": "Tank",
		"teamRole": "tank",
		"icon": "dva.png",
		"roleRank": 4
	},
	{
		"name": "Reinhardt",
		"role": "Tank",
		"teamRole": "tank",
		"icon": "reinhardt.png",
		"roleRank": 2
	},
	{
		"name": "Roadhog",
		"role": "Tank",
		"teamRole": "tank",
		"icon": "roadhog.png",
		"roleRank": 3
	},
	{
		"name": "Winston",
		"role": "Tank",
		"teamRole": "tank",
		"icon": "winston.png",
		"roleRank": 5
	},
	{
		"name": "Zarya",
		"role": "Tank",
		"teamRole": "tank",
		"icon": "zarya.png",
		"roleRank": 1
	},
	{
		"name": "Ana",
		"role": "Support",
		"teamRole": "support",
		"icon": "ana.png",
		"roleRank": 4
	},
	{
		"name": "Lúcio",
		"role": "Support",
		"teamRole": "support",
		"icon": "lucio.png",
		"roleRank": 1
	},
	{
		"name": "Mercy",
		"role": "Support",
		"teamRole": "support",
		"icon": "mercy.png",
		"roleRank": 3
	},
	{
		"name": "Symmetra",
		"role": "Support",
		"teamRole": "support",
		"icon": "symmetra.png",
		"roleRank": 5
	},
	{
		"name": "Zenyatta",
		"role": "Support",
		"teamRole": "support",
		"icon": "zenyatta.png",
		"roleRank": 2
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/heros_ranks.json
 ** module id = 98
 ** module chunks = 0
 **/